// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EvaluationPreviewModal .Modal-Dialog .Modal-Content {
  max-height: 90vh;
}
.EvaluationPreviewModal .Modal-Dialog .Modal-Body {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1 1 auto;
  min-height: 0;
}
.EvaluationPreviewModal .Form {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
.EvaluationPreviewModal-Questions {
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}
.EvaluationPreviewModal-Footer {
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  padding-top: 0.75rem;
  margin-top: 0.75rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.EvaluationPreviewModal-Actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}
.EvaluationPreviewModal-Error {
  color: var(--bs-danger);
  font-weight: 500;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/pages/Users/components/EvaluationPreviewModal/styles.scss"],"names":[],"mappings":"AAEI;EACE,gBAAA;AADN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AADN;AAKE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;AAHJ;AAME;EACE,gBAAA;EACA,cAAA;EACA,aAAA;AAJJ;AAOE;EACE,cAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,wCAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AANJ;AASE;EACE,uBAAA;EACA,gBAAA;EACA,iBAAA;AAPJ","sourcesContent":[".EvaluationPreviewModal {\n  .Modal-Dialog {\n    .Modal-Content {\n      max-height: 90vh;\n    }\n    .Modal-Body {\n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n      flex: 1 1 auto;\n      min-height: 0;\n    }\n  }\n\n  .Form {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    min-height: 0;\n  }\n\n  &-Questions {\n    overflow-y: auto;\n    flex: 1 1 auto;\n    min-height: 0;\n  }\n\n  &-Footer {\n    flex: 0 0 auto;\n    display: flex;\n    justify-content: space-between;\n    gap: 0.75rem;\n    padding-top: 0.75rem;\n    margin-top: 0.75rem;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n  }\n\n  &-Actions {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    min-width: 0;\n  }\n\n  &-Error {\n    color: var(--bs-danger);\n    font-weight: 500;\n    text-align: right;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
